import { styled } from "@mui/material/styles";
import React from "react";
import GenerateImageEditorButtons from "./GenerateImageEditorButtons";
import MarketingFlyerModalBody from "./MarketingFlyerModalBody";

const StyledDiv = styled("div")(({ customWidth }) => ({
    flexGrow: 1,
    flexbasis: "100%",
    width: customWidth || "auto",
}));

const MarketingFlyerModalBodyContainer = (props) => {
    const {
        handleCloseModal,
        handleGenerateMarketingFlyerReport,
        handleSelectPhotoFromDropdown,
        shouldDisableButtons,
    } = props;

    return (
        <React.Fragment>
            <MarketingFlyerModalBody {...props} />
            <StyledDiv customWidth="33%" style={{ paddingTop: "22px", textAlign: "end" }}>
                <GenerateImageEditorButtons
                    handleCloseModal={handleCloseModal}
                    handleGenerateClick={handleGenerateMarketingFlyerReport}
                    handleSelectPhotoFromDropdown={handleSelectPhotoFromDropdown}
                    shouldDisableButtons={shouldDisableButtons}
                />
            </StyledDiv>
        </React.Fragment>
    );
};

export default MarketingFlyerModalBodyContainer;
